import validate from './validate';
export const getPriceSuf = (price) => {//截取价格小数部分
    if(price){
        price = price + '';
        let priceArray = price.split('.');
        if(priceArray.length == 2){
            let priceSuf = priceArray[1];
            if(priceSuf.length == 1){
                priceSuf = '.' + priceSuf + '0';
                return priceSuf;
            }else if(priceSuf.length == 2){
                return '.' + priceSuf;
            }
        }
        return '';
    }
};

export const getPricePref = (price) => {//截取价格整数部分
    if(price){
        price = price + '';
        let pricePref = price.split('.')[0];
        return pricePref;
    }
    return price;
};

export const checkCardNoBirthdayIsOk = (certificateNo, ageNumStart, ageNumEnd, sureDateNum = 1)=>{
    let birthday = certificateNo.substring(6,14);
    if(birthday.length == 8){
        birthday = birthday.substring(0, 4) + '-' + birthday.substring(4 , 6) + '-' + birthday.substring(6 , 8);
        // console.log(111111111,birthday);
        return validate.checkBirthdayIsOk(birthday, ageNumStart, ageNumEnd);
    }
    return '';
};

//encodeURI
export const urlencode=(str)=>{
    str = (str + '').toString();
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
};

export const getQueryString = (name) => {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {return decodeURIComponent(r[2]);}
    return null;
};

//修复ios页面下拉留白的问题
export const patchIosBlank = () => {
    var inputK = document.getElementsByTagName('input');
    var textArea = document.getElementsByTagName('textarea');
    //需要手动给有输入功能的div框加上类名 divIos
    var divIos = document.getElementsByClassName('divIos');
    var input = [...inputK,...textArea,...divIos];
    const windowHeight = window.innerHeight;
    for (let i = 0; i < input.length; i++) {
        input[i].addEventListener('blur', function () {
            let windowFocusHeight = window.innerHeight;
            if (windowHeight === windowFocusHeight) {
                return;
            };
            let currentPosition;
            let speed = 1; //页面滚动距离
            currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
            currentPosition -= speed;
            window.scrollTo(0, currentPosition); //页面向上滚动
            currentPosition += speed; //speed变量
            window.scrollTo(0, currentPosition); //页面向下滚动
        });
    }
};

// 判断是否是国美家app 环境
// export const isGomeHome = sessionStorage['appEnv'] && sessionStorage['appEnv'] === 'gomeHome';
export const isGomeHome = !!window.navigator.userAgent.toLowerCase().match(/gomehome/ig);
// !!window.navigator.userAgent.toLowerCase().match(/gomehome/ig);

// 判断是否是国美金融app 环境
export const isSource = sessionStorage['source'] && sessionStorage['source'] === 'app';
// !!window.navigator.userAgent.toLowerCase().match(/gomehome/ig);

// 判断是不是美付保环境
export const isGomePay = !!window.navigator.userAgent.toLowerCase().match(/gomePay/ig);
// export const isGomePay = null;

// 判断是否是易卡APP环境
export const isYKApp = !!window.navigator.userAgent.toLowerCase().match(/gomecard/ig);

// 判断是不是美办app环境
export const isMeiBan = !!window.navigator.userAgent.toLowerCase().match(/smartoffice/ig);

// 判断是不是真快乐app环境、
export const iszkl = !!window.navigator.userAgent.toLowerCase().match(/app-shangcheng/ig);
// 判断是不是安卓
export const isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;



// WEBPACK FOOTER //
// ./src/utils/util.js